import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { GridSmartViewsController } from '../controller/GridSmartViewsController';
import { SmartViewSection, ViewType } from '../types';
import { SaveViewFormDialogSchema } from '../../uiElements/smartViewSaveDialog/types';
import { Column, Filter } from '@nirvana/shared/dtos/types/shared/filters';

export class GridSmartViewsWebComponent<Col = Column, Fil = Filter, Type = ViewType> extends BaseWebComponentElement {
  private _sections: Array<SmartViewSection<Col, Fil, Type>>;
  private _activeViewId: string;
  public controller: GridSmartViewsController<Col, Fil, Type>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GridSmartViewsController,
    });
  }

  set sections(value: Array<SmartViewSection<Col, Fil, Type>>) {
    this._sections = value;
  }

  get sections(): Array<SmartViewSection<Col, Fil, Type>> {
    return this._sections ?? [];
  }

  set activeViewId(value: string) {
    this._activeViewId = value;
  }

  get activeViewId(): string {
    return this._activeViewId;
  }

  public showSaveViewDialog(config: SaveViewFormDialogSchema) {
    this.controller.showSaveAsDialog(config);
  }

  public async reloadSections() {
    await this.controller.reloadSections();
  }
}
